import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "currentRole", "pharmacyList"]
  static values = {
    currentPharmacyId: Number,
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden")
      // Use requestAnimationFrame for smooth animation
      requestAnimationFrame(() => {
        this.menuTarget.classList.add("opacity-100", "scale-100")
        this.menuTarget.classList.remove("opacity-0", "scale-95")
      })
    } else {
      this.menuTarget.classList.add("opacity-0", "scale-95")
      this.menuTarget.classList.remove("opacity-100", "scale-100")
      setTimeout(() => {
        this.menuTarget.classList.add("hidden")
      }, 150)
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.openValue = false
    }
  }

  select(event) {
    // Form submission is handled by Turbo
    this.openValue = false
  }
}
